import React from 'react';
import Page from '../components/Governanca/Page';
import '../assets/css/little_wallet_new.css';


const Governanca = () => {

    return (
        <div>
            <Page />
        </div>
    );
};

export default Governanca;


/** WEBPACK FOOTER **
 ** ./src/containers/Governanca.js
 **/